import styled from 'styled-components';

const StyledBigTextCenter = styled.div`
  position:  relative;
  text-align: center;
  padding-top: ${props => props.theme.components_spacing_desk.xxlarge}px;
  max-width: 70%;
  margin: 0 auto;
  p{
    padding-top: 24px;
    color: ${props => props.theme.colors.grey_700 };
  }
  @media screen and (max-width: 1439px){
    padding-top: ${props => props.theme.components_spacing_desk.xxlarge}px;
  }
  @media screen and (max-width: 1023px){
    padding-top: ${props => props.theme.components_spacing_tablet.xxlarge}px;
    max-width: 83.33%;
  }
  @media screen and (max-width: 767px){
    padding-top: ${props => props.theme.components_spacing_mobile.xxlarge}px;
    p{
      padding-top: 16px;
    }
  }
`;
export {
  StyledBigTextCenter,
};

